module.exports = __webpack_public_path__ + "img/7.81f5bfc1.jpg";